import { coreSystemWebModule } from '@portal/module-core-system/web';
import type { WebModuleDefinition } from '@portal/web-sdk';
import { coreAuditWebModule } from '@portal/module-core-audit/web';
import { coreIdentityWebModule } from '@portal/module-core-identity/web';
import { coreOrganizationWebModule } from '@portal/module-core-organization/web';
import { coreAccessWebModule } from '@portal/module-core-access/web';
import { youtubeWebModule } from '@portal/module-youtube/web';
import { coreNotificationWebModule } from '@portal/module-core-notification/web';
import { coreFilesWebModule } from '@portal/module-core-files/web';
import { coreBackupWebModule } from '@portal/module-core-backup/web';
import { partnersWebModule } from '@portal/module-partners/web';
import { requestsWebModule } from '@portal/module-requests/web';
import { tasksWebModule } from '@portal/module-tasks/web';
import { calendarWebModule } from '@portal/module-calendar/web';
import { chatWebModule } from '@portal/module-chat/web';
import { attendanceWebModule } from '@portal/module-attendance/web';

/** Compile-time module registry of the web shell. Must list the same modules as apps/api/src/modules.ts. */
export const webModules: WebModuleDefinition[] = [
  coreSystemWebModule,
  coreAuditWebModule,
  coreIdentityWebModule,
  coreOrganizationWebModule,
  coreAccessWebModule,
  coreNotificationWebModule,
  coreFilesWebModule,
  coreBackupWebModule,
  partnersWebModule,
  youtubeWebModule,
  requestsWebModule,
  tasksWebModule,
  calendarWebModule,
  chatWebModule,
  attendanceWebModule,
];
